import React from "react";
import { useTranslation } from "react-i18next";
import { Footer } from "@common/AggregationComponent";
import { useSelector } from "react-redux";
import type { CombinedReducersType } from "@type/index";

const PublicFooter = () => {
  const { t } = useTranslation();
  const config = useSelector((store: CombinedReducersType) => store.app);
  return !config.isApp ? (
    <Footer copyrightRow={t("text_copyright")} variant="default" />
  ) : (
    <></>
  );
};

export default PublicFooter;
